module.exports = __webpack_public_path__ + "img/labmemtest_text_nextbtn_sc.83bc489b.png";